import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "../stores/auth";
import HomeView from "../views/HomeView.vue";
import AdminWorksView from "../views/AdminWorksView.vue";
import DashboardView from "../views/DashboardView.vue";
import SettingsView from "../views/SettingsView.vue";
import ProfileView from "../views/ProfileView.vue";
import PrivacyPolicyView from "../views/PrivacyPolicyView.vue";
import TermsConditionsView from "../views/TermsConditionsView.vue";
import ContactView from "../views/ContactView.vue";
import DocumentationView from "../views/DocumentationView.vue";
import RegistrationView from "../views/RegistrationView.vue";
import WelcomeGetStarted from "../views/WelcomeGetStarted.vue";
import POSListView from "../features/revenue/sales/pos/POSListView.vue";
import CompanyCreationView from "../views/CompanyCreationView.vue";
import ActivateUserEmail from "../components/auth/registration/ActivateUserEmail.vue";
import CustomerTypesListView from "../features/revenue/masterdata/customertypes/CustomerTypesListView.vue";
import CustomersListView from "../features/revenue/masterdata/customers/CustomersListView.vue";
import SalesChannelsListView from "../features/revenue/masterdata/saleschannels/SalesChannelsListView.vue";
import CustomerGroupsListView from "../features/revenue/masterdata/customergroups/CustomerGroupsListView.vue";
import SalesRepsListView from "../features/revenue/masterdata/salesreps/SalesRepsListView.vue";
import PromotionsListView from "../features/revenue/sales/promotions/PromotionsListView.vue";
import SalesQuotationsListView from "../features/revenue/sales/salesquotations/SalesQuotationsListView.vue";
import SalesOrdersListView from "../features/revenue/sales/salesorders/SalesOrdersListView.vue";
import SalesGoodsDeliverysListView from "../features/revenue/sales/salesgoodsdeliverys/SalesGoodsDeliverysListView.vue";
import SalesGoodsReturnsListView from "../features/revenue/sales/salesgoodsreturns/SalesGoodsReturnsListView.vue";
import SalesInvoicesListView from "../features/revenue/sales/salesinvoices/SalesInvoicesListView.vue";
import SalesCreditNotesListView from "../features/revenue/sales/salescreditnotes/SalesCreditNotesListView.vue";
import DeliveryTrackingsListView from "../features/revenue/sales/deliverytrackings/DeliveryTrackingsListView.vue";
import VendorTypesListView from "../features/procurement/masterdata/vendortypes/VendorTypesListView.vue";
import VendorsListView from "../features/procurement/masterdata/vendors/VendorsListView.vue";
import PurchaseRequestsListView from "../features/procurement/purchases/purchaserequests/PurchaseRequestsListView.vue";
import PurchaseOrdersListView from "../features/procurement/purchases/purchaseorders/PurchaseOrdersListView.vue";
import PurchaseGoodsReceiptsListView from "../features/procurement/purchases/purchasegoodsreceipts/PurchaseGoodsReceiptsListView.vue";
import PurchaseInvoicesListView from "../features/procurement/purchases/purchaseinvoices/PurchaseInvoicesListView.vue";
import PurchaseGoodsReturnsListView from "../features/procurement/purchases/purchasegoodsreturns/PurchaseGoodsReturnsListView.vue";
import PurchaseDebitNotesListView from "../features/procurement/purchases/purchasedebitnotes/PurchaseDebitNotesListView.vue";
import ItemsListView from "../features/inventory/itemmanagement/items/ItemsListView.vue";
import BrandsListView from "../features/inventory/itemmanagement/brands/BrandsListView.vue";
import ItemCategoriesListView from "../features/inventory/itemmanagement/itemcategories/ItemCategoriesListView.vue";
import ItemGroupsListView from "../features/inventory/itemmanagement/itemgroups/ItemGroupsListView.vue";
import ItemTypesListView from "../features/inventory/itemmanagement/itemtypes/ItemTypesListView.vue";
import UnitOfMeasuresListView from "../features/inventory/itemmanagement/unitofmeasures/UnitOfMeasuresListView.vue";
import VariantsListView from "../features/inventory/itemmanagement/variants/VariantsListView.vue";
import CurrencyListView from "../features/finance/masterdata/currency/CurrencyListView.vue";
import CreditTermsListView from "../features/finance/masterdata/creditterms/CreditTermsListView.vue";
import PriceListsListView from "../features/finance/masterdata/pricelists/PriceListsListView.vue";
import TaxDefinitionsListView from "../features/finance/masterdata/taxdefinitions/TaxDefinitionsListView.vue";
import PaymentTypesListView from "../features/finance/masterdata/paymenttypes/PaymentTypesListView.vue";
import AccountGroupsListView from "../features/finance/accounting/AccountGroups/AccountGroupsListView.vue";
import AccountTypesListView from "../features/finance/accounting/AccountTypes/AccountTypesListView.vue";
import AssetsListView from "../features/finance/accounting/Assets/AssetsListView.vue";
import AssetTemplatesListView from "../features/finance/accounting/AssetTemplates/AssetTemplatesListView.vue";
import AssetGroupsListView from "../features/finance/accounting/AssetGroups/AssetGroupsListView.vue";
import ChartOfAccountsListView from "../features/finance/accounting/ChartOfAccounts/ChartOfAccountsListView.vue";
import PaymentReceiptsListView from "../features/finance/paymentreceipts/paymentreceipts/PaymentReceiptsListView.vue";
import CompanyInformationListView from "../features/system/company/companyinformation/CompanyInformationListView.vue";
import OutletsListView from "../features/system/company/outlets/OutletsListView.vue";
import WarehousesListView from "../features/system/company/warehouses/WarehousesListView.vue";
import ApartmentsListView from "../features/system/masterdata/apartments/ApartmentsListView.vue";
import BuildingsListView from "../features/system/masterdata/buildings/BuildingsListView.vue";
import CitysListView from "../features/system/masterdata/citys/CitysListView.vue";
import CountrysListView from "../features/system/masterdata/countrys/CountrysListView.vue";
import RoadsListView from "../features/system/masterdata/roads/RoadsListView.vue";
import StatesListView from "../features/system/masterdata/states/StatesListView.vue";
import CashierDutysListView from "../features/system/security/cashierdutys/CashierDutysListView.vue";
import RolesListView from "../features/system/security/roles/RolesListView.vue";
import UsersListView from "../features/system/security/users/UsersListView.vue";
import UpgradesListView from "../features/admin/upgrades/UpgradesListView.vue";
import LedgerEntriesListView from "../features/finance/accounting/ledgerentries/LedgerEntriesListView.vue";
import CostingSheetsListView from "../features/procurement/purchases/costingsheets/CostingSheetsListView.vue";
import StockRequestsListView from "../features/inventory/inventorymanagement/stockrequests/StockRequestsListView.vue";
import StockTransfersListView from "../features/inventory/inventorymanagement/stocktransfers/StockTransfersListView.vue";
import StockAdjustmentsListView from "../features/inventory/inventorymanagement/stockadjustments/StockAdjustmentsListView.vue";
import StockCountsListView from "../features/inventory/inventorymanagement/stockcounts/StockCountsListView.vue";
import StockTransferReceiptsListView from "../features/inventory/inventorymanagement/stocktransfers/StockTransferReceiptsListView.vue";
import BillPaymentsListview from "../features/finance/accounting/billpayments/BillPaymentsListview.vue";
import ItemPricesListView from "../features/inventory/itemmanagement/itemprices/ItemPricesListView.vue";
import ItemInventoryListView from "../features/inventory/itemmanagement/iteminventory/ItemInventoryListView.vue";
import PosStationsListView from "../features/system/company/outlets/PosStationsListView.vue";
import ShiftEndReportsListView from "../features/finance/paymentreceipts/shiftendreports/ShiftEndReportsListView.vue";
import { tokenManager } from "../api/utils/tokenManager";
import ProjectsListView from "../features/revenue/masterdata/projects/ProjectsListView.vue";
import StockIssuesListView from "../features/inventory/inventorymanagement/stockissues/StockIssuesListView.vue";
//import ForgotPasswordForm from "../components/auth/ForgotPasswordForm.vue";
import ForgotPassword from "../components/auth/registration/ForgotPassword.vue";
import ChangePassword from "../components/auth/registration/ChangePassword.vue";
import RunningExpensesListView from "../features/finance/accounting/runningexpenses/RunningExpensesListView.vue";
import MobileSalesView from "../features/revenue/sales/mobilesales/MobileSalesView.vue";
import ProfitLossReport from "../components/reports/ProfitLossReport.vue";
import ProfitLossMonthlyReport from "../components/reports/ProfitLossMonthlyReport.vue";
import BalanceSheet from "../components/reports/BalanceSheet.vue";
import ReportDesigner from "../components/reports/ReportDesigner.vue";
import StockAdjustmentTypesListView from "../features/inventory/inventorymanagement/stockadjustmenttypes/StockAdjustmentTypesListView.vue";
import ExchangeRatesListView from "../features/finance/masterdata/exchangerates/ExchangeRatesListView.vue";
import ReportManager from "../components/reports/ReportManager.vue";
import TrialBalance from "../components/reports/TrialBalance.vue";
import AccountReconciliations from "../features/finance/accounting/ChartOfAccounts/AccountReconciliations.vue";
import EcommerceSetupsListView from "../features/system/company/ecommerce/EcommerceSetupsListView.vue";
import MobilePos from "../features/revenue/sales/pos/mobilepos/MobilePos.vue";
import KitchenOrdersList from "../features/revenue/sales/kitchekorders/KitchenOrdersList.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { requiresGuest: true }
    },
    {
      path: '/ddmin',
      name: 'ddmin',
      component: AdminWorksView,
      meta: { requiresAuth: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardView,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'settings',
      component: SettingsView,
      meta: { requiresAuth: true }
    },
    {
      path: '/profile',
      name: 'profile',
      component: ProfileView,
      meta: { requiresAuth: true }
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: ChangePassword,
      meta: { requiresAuth: true }
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicyView
    },
    {
      path: '/terms-conditions',
      name: 'terms-conditions',
      component: TermsConditionsView
    },
    {
      path: '/contact',
      name: 'contact',
      component: ContactView
    },
    {
      path: '/documentation',
      name: 'documentation',
      component: DocumentationView
    },
    {
      path: '/register',
      name: 'register',
      component: RegistrationView
    },
    {
      path: '/welcome',
      name: 'welcome-get-started',
      component: WelcomeGetStarted,
      meta: { requiresAuth: true }
    },
    {
      path: '/pos',
      name: 'pos',
      component: POSListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/mobile-pos',
      name: 'mobile-pos',
      component: MobilePos,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/sales/pos',
      name: 'sales-pos',
      component: POSListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/create-company/:id',
      name: 'company-creation',
      component: CompanyCreationView,
    },
    {
      path: '/activate-email/:id',
      name: 'activate-email',
      component: ActivateUserEmail,
    },
    {
      path: '/forgot-password/:id',
      name: 'forgot-password',
      component: ForgotPassword,
    },
    //admin
    {
      path: '/admin/upgrades',
      name: 'admin-upgrades',
      component: UpgradesListView,
      meta: { requiresAuth: true }
    },
    //admin end 
    //Revenue > Master Data 
    {
      path: '/revenue/master-data/customer-types',
      name: 'customer-types',
      component: CustomerTypesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/master-data/customers',
      name: 'customers',
      component: CustomersListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/master-data/projects',
      name: 'projects',
      component: ProjectsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/master-data/sales-channels',
      name: 'sales-channels',
      component: SalesChannelsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/master-data/customer-groups',
      name: 'customer-groups',
      component: CustomerGroupsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/master-data/sales-reps',
      name: 'sales-reps',
      component: SalesRepsListView,
      meta: { requiresAuth: true }
    },
    //Revenue > Sales
    {
      path: '/revenue/sales/sales-quotations',
      name: 'sales-quotations',
      component: SalesQuotationsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/sales/promotions',
      name: 'promotions',
      component: PromotionsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/sales/sales-orders',
      name: 'sales-orders',
      component: SalesOrdersListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/sales/sales-goods-deliverys',
      name: 'sales-goods-deliverys',
      component: SalesGoodsDeliverysListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/sales/sales-goods-returns',
      name: 'sales-goods-return',
      component: SalesGoodsReturnsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/sales/mobile-sales',
      name: 'mobile-sales',
      component: MobileSalesView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/sales/sales-invoices',
      name: 'sales-invoices',
      component: SalesInvoicesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/sales/sales-credit-notes',
      name: 'sales-credit-notes',
      component: SalesCreditNotesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/sales/delivery-trackings',
      name: 'delivery-trackings',
      component: DeliveryTrackingsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/revenue/sales/kitchen-orders',
      name: 'kitchen-orders',
      component: KitchenOrdersList,
      meta: { requiresAuth: true }
    },
    //Procurement > Master Data
    {
      path: '/procurement/master-data/vendor-types',
      name: 'vendor-types',
      component: VendorTypesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/procurement/master-data/vendors',
      name: 'vendors',
      component: VendorsListView,
      meta: { requiresAuth: true }
    },
    //Procurement > Purchases 
    {
      path: '/procurement/purchases/purchase-requests',
      name: 'purchase-request',
      component: PurchaseRequestsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/procurement/purchases/purchase-orders',
      name: 'purchase-order',
      component: PurchaseOrdersListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/procurement/purchases/purchase-goods-receipts',
      name: 'purchase-goods-receipts',
      component: PurchaseGoodsReceiptsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/procurement/purchases/purchase-invoices',
      name: 'purchase-invoice',
      component: PurchaseInvoicesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/procurement/purchases/purchase-goods-returns',
      name: 'purchase-goods-return',
      component: PurchaseGoodsReturnsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/procurement/purchases/purchase-debit-notes',
      name: 'purchase-debit-notes',
      component: PurchaseDebitNotesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/procurement/purchases/costing-sheets',
      name: 'costing-sheets',
      component: CostingSheetsListView,
      meta: { requiresAuth: true }
    },
    //Inventory > Item management
    {
      path: '/inventory/item-management/items',
      name: 'items',
      component: ItemsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/item-management/item-prices',
      name: 'item-prices',
      component: ItemPricesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/item-management/inventory',
      name: 'item-inventory',
      component: ItemInventoryListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/item-management/brands',
      name: 'brands',
      component: BrandsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/item-management/item-categories',
      name: 'item-categories',
      component: ItemCategoriesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/item-management/item-groups',
      name: 'item-groups',
      component: ItemGroupsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/item-management/item-types',
      name: 'item-types',
      component: ItemTypesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/item-management/unit-of-measures',
      name: 'unit-of-measures',
      component: UnitOfMeasuresListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/item-management/variants',
      name: 'variants',
      component: VariantsListView,
      meta: { requiresAuth: true }
    },
    //Inventory > Inventory management
    {
      path: '/inventory/inventory-management/stock-requests',
      name: 'stock-requests',
      component: StockRequestsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/inventory-management/stock-transfers',
      name: 'stock-transfers',
      component: StockTransfersListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/inventory-management/stock-transfer-receipts',
      name: 'stock-transfer-receipts',
      component: StockTransferReceiptsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/inventory-management/stock-issue',
      name: 'stock-issues',
      component: StockIssuesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/inventory-management/stock-adjustments',
      name: 'stock-adjustments',
      component: StockAdjustmentsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/inventory-management/stock-adjustment-types',
      name: 'stock-adjustment-types',
      component: StockAdjustmentTypesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/inventory-management/stock-counts',
      name: 'stock-counts',
      component: StockCountsListView,
      meta: { requiresAuth: true }
    },
    //Finance > Master Data 
    {
      path: '/finance/master-data/currency',
      name: 'currency',
      component: CurrencyListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/master-data/exchange-rates',
      name: 'exchange-rates',
      component: ExchangeRatesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/master-data/credit-terms',
      name: 'credit-terms',
      component: CreditTermsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/master-data/price-lists',
      name: 'price-lists',
      component: PriceListsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/master-data/tax-definitions',
      name: 'tax-definitions',
      component: TaxDefinitionsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/master-data/payment-types',
      name: 'payment-types',
      component: PaymentTypesListView,
      meta: { requiresAuth: true }
    },
    //Finance > Accounting 
    {
      path: '/finance/accounting/bill-payments',
      name: 'bill-payments',
      component: BillPaymentsListview,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/accounting/account-groups',
      name: 'account-groups',
      component: AccountGroupsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/accounting/account-types',
      name: 'account-types',
      component: AccountTypesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/accounting/assets',
      name: 'assets',
      component: AssetsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/accounting/asset-templates',
      name: 'asset-templates',
      component: AssetTemplatesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/accounting/asset-groups',
      name: 'asset-groups',
      component: AssetGroupsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/accounting/ledger-entries',
      name: 'ledger-entries',
      component: LedgerEntriesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/accounting/chart-of-accounts',
      name: 'chart-of-accounts',
      component: ChartOfAccountsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/accounting/reconciliation',
      name: 'account-reconciliation',
      component: AccountReconciliations,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/accounting/running-expenses',
      name: 'running-expenses',
      component: RunningExpensesListView,
      meta: { requiresAuth: true }
    },
    //Finance > Payument Receipts 
    {
      path: '/finance/collections/payment-receipts',
      name: 'payment-receipts',
      component: PaymentReceiptsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/finance/collections/shift-end-reports',
      name: 'shift-end-reports',
      component: ShiftEndReportsListView,
      meta: { requiresAuth: true }
    },
    //System > Company
    {
      path: '/system/company/company-information',
      name: 'company-information',
      component: CompanyInformationListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/company/outlets',
      name: 'outlets',
      component: OutletsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/company/ecommerce-setups',
      name: 'ecommerce-setups',
      component: EcommerceSetupsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/company/pos-stations',
      name: 'pos-stations',
      component: PosStationsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/company/warehouses',
      name: 'warehouses',
      component: WarehousesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/company/settings',
      name: 'settings',
      component: SettingsView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/company/report-manager',
      name: 'report-manager',
      component: ReportManager,
      meta: { requiresAuth: true }
    },
    //System > Master Data
    {
      path: '/system/master-data/apartments',
      name: 'apartments',
      component: ApartmentsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/master-data/buildings',
      name: 'buildings',
      component: BuildingsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/master-data/citys',
      name: 'citys',
      component: CitysListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/master-data/countrys',
      name: 'countrys',
      component: CountrysListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/master-data/roads',
      name: 'roads',
      component: RoadsListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/master-data/states',
      name: 'states',
      component: StatesListView,
      meta: { requiresAuth: true }
    },
    //System > Secruity
    {
      path: '/system/security/cashier-dutys',
      name: 'cashier-dutys',
      component: CashierDutysListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/security/roles',
      name: 'roles',
      component: RolesListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/system/security/users',
      name: 'users',
      component: UsersListView,
      meta: { requiresAuth: true }
    },
    //Reports
    {
      path: '/reports/profit-loss',
      name: 'profit-loss',
      component: ProfitLossReport,
      meta: { requiresAuth: true }
    },
    {
      path: '/reports/profit-loss-month',
      name: 'profit-loss-month',
      component: ProfitLossMonthlyReport,
      meta: { requiresAuth: true }
    },
    {
      path: '/reports/balance-sheet',
      name: 'balance-sheet',
      component: BalanceSheet,
      meta: { requiresAuth: true }
    },
    {
      path: '/reports/trial-balance',
      name: 'trial-balance',
      component: TrialBalance,
      meta: { requiresAuth: true }
    },
    {
      path: '/reports/designer',
      name: 'report-designer',
      component: ReportDesigner,
      meta: { requiresAuth: true }
    },
    {
      path: '/reports/designer/:id',
      name: 'report-designer-id',
      component: ReportDesigner,
      meta: { requiresAuth: true }
    },
  ]
})


router.beforeEach(async (to, _from, next) => {
  const store = useAuthStore()

  if (to.meta.requiresAuth && !store.isAuthenticated) {
    next({ name: 'home' })
  } else if (to.meta.requiresGuest && store.isAuthenticated) {
    //next({ name: 'dashboard' })
    const user = tokenManager.getUser()
    if (user?.user_type == 'Back Office') {
      next({ name: 'dashboard' })
    } else if (user?.user_type == 'POS User') {
      next({ name: 'pos' })
    } else if (user?.user_type == 'Delivery') {
      next({ name: 'delivery-trackings' })
    } else if (user?.user_type == 'Sales Rep') {
      next({ name: 'reps' })
    } else {
      next({ name: 'dashboard' })
    }
  } else 
  {
    next()
  }
})

// Track page loads
router.afterEach((_to) => {
  //eventTracker.trackPageLoad(to.path, document.title)
});

export default router;
